import { Injectable } from "@angular/core";
import { Product, ProductPageMetaResolver } from "@spartacus/core";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class UigProductPageMetaResolver extends ProductPageMetaResolver {
  resolveHeading(): Observable<string> {
    return this.product$.pipe(
      switchMap((p: Product) =>
        this.translation.translate("pageMetaResolver.product.heading", {
          heading: p.name + " [" + p.code + "]",
        })
      )
    );
  }
}
